import * as React from 'react';

import * as styles from './InfrastructureLegendSection.css';

export const InfrastructureLegendSection: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['container']}>{children}</div>
);
